// Finland timezone + locale-aware date/time formatting.
export const fmtDateTime = (value, lang) => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "";
  const locale = lang === "fi" ? "fi-FI" : "en-GB";
  return new Intl.DateTimeFormat(locale, {
    timeZone: "Europe/Helsinki",
    dateStyle: "medium",
    timeStyle: "short",
  }).format(d);
};
